import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

export default function UnauthorizedModal(props: { onClose: () => void }) {
	const { t } = useTranslation();
	return <Dialog
		open={true}
		onClose={(e) => props.onClose()}
	>
		<DialogTitle>Brak wymaganych uprawnień!</DialogTitle>
		<DialogContent>
			<DialogContentText>
				Skontaktuj się z administratorem...
			</DialogContentText>
		</DialogContent>
		<DialogActions>
			<Button onClick={(e) => props.onClose()} color="default" variant="contained">
				{t("common.action.close")}
			</Button>
		</DialogActions>
	</Dialog>
}